import Joi from 'joi';

const baseSchema = {
  title: Joi.string().required(),
  content: Joi.string().required(),
  category: Joi.string().required(),
  relatedCafes: Joi.array().items(Joi.string().required()),
  attachmentData: Joi.array(),
};

export const noteSchema = Joi.object({
  ...baseSchema,
});
